export interface MsGraphApiData<DataType> {
  value: DataType;
}

/**
 * User Profile interface with data coming back from azure graph
 * ** Some of the attributes are missing, you can add them as we use them.
 */
export interface UserProfileMsGraph {
  city: string;
  companyName: string;
  country: string;
  displayName: string;
  givenName: string;
  mail: string;
  mailNickname: string;
  id: string;
  surname: string;
  usageLocation: string;
  userType: string;
  lastDirSyncTime: string;
  userPrincipalName: string;
  manager?: UserProfileMsGraph;
  thumbnailPhotoUrl?: string;
  externalUserState?: ExternalUserState;
}

export enum ExternalUserState {
  PENDING_ACCEPTANCE = 'PendingAcceptance',
  ACCEPTED = 'Accepted'
}

export interface UserGraphApiData extends MsGraphApiData<UserProfileMsGraph[]> {}
